// src/themes/royal-gold.ts
import { Theme } from "./types";

export const royalGoldTheme: Theme = {
  "background-light": "23 18 12", // #17120C - Rich dark chocolate
  "background-dark": "18 14 8", // #120E08 - Deeper chocolate
  "card-light": "43 33 18", // #2B2112 - Dark bronze
  "card-dark": "36 27 13", // #241B0D - Darker bronze
  "input-light": "59 46 25", // #3B2E19 - Warm brown
  "input-dark": "52 40 20", // #342814 - Darker warm brown
  "border-light": "120 98 56", // #786238 - Aged gold border
  "border-dark": "105 85 45", // #69552D - Darker gold border
  primary: "212 175 55", // #D4AF37 - Premium gold
  "primary-hover": "184 150 40", // #B89628 - Rich gold
  text: "245 230 200", // #F5E6C8 - Soft champagne
  "text-dark": "235 220 190", // #EBDCBE - Warm cream
  "text-secondary": "200 180 140", // #C8B48C - Muted gold
  "text-secondary-dark": "180 160 120", // #B4A078 - Aged gold
};
